import React, { useState } from 'react'
import { Button, colors, Popup, Typography } from '@microfrontends/react-components'
import { HIDE_MY_PROFILE_MAX, MAX_COMPANY_NAME } from '../constants'
import InputGroup from '../InputGroup'
import { EDevice, useStore } from '../../../../store'
import {
    CompanyBox,
    Section,
    SectionContent,
    SectionTitle,
    SubTitle,
    WrapSwitcher,
    WrapSwitcherMobile
} from './HideMyProfile.css'
import { THideMyProfileProps } from '../type'

export default function HideMyProfile(props: THideMyProfileProps) {
    const { trans } = props
    const { user } = useStore().state
    return (
        <Section>
            <Typography name='title' size='medium' color={colors.grey[20]}>
                {trans('Hide My profile from Company')}
            </Typography>
            <SectionContent>
                <CompanyBox>
                    <Typography name='body' size='medium' color={colors.grey[20]}>
                        {trans("Enter company's email domain")} <span>{trans('Recommended')}</span>
                    </Typography>
                    <InputGroup
                        max={HIDE_MY_PROFILE_MAX}
                        prefixText='@'
                        placeholder='navigosgroup.com'
                        isInputCompanyName={false}
                        isMobile={false}
                        trans={trans}
                        userToken={user?.accessToken || ''}
                    />
                </CompanyBox>
                <CompanyBox>
                    <Typography name='body' size='medium' color={colors.grey[20]}>
                        {trans('Or enter a company name')}
                    </Typography>
                    <InputGroup
                        max={MAX_COMPANY_NAME}
                        prefixText=''
                        placeholder='Navigos Group VN'
                        isInputCompanyName={true}
                        isMobile={false}
                        trans={trans}
                        userToken={user?.accessToken || ''}
                    />
                </CompanyBox>
            </SectionContent>
        </Section>
    )
}
